import { Leaf } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-border/30 mt-12" data-testid="app-footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-8 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <Leaf className="w-4 h-4 text-primary/50" />
          <span className="text-sm text-white/30 font-medium" style={{ fontFamily: "Manrope, sans-serif" }}>
            Olana
          </span>
          <span className="text-xs text-white/15 ml-1">
            Sustainability intelligence for a regenerative economy
          </span>
        </div>
        <span className="text-xs text-white/20">
          &copy; {new Date().getFullYear()} Olana. All rights reserved.
        </span>
      </div>
    </footer>
  );
}
